import { createFileRoute } from "@tanstack/react-router";
import HowLongDoesTaxResolutionTake from "@/pages/site/HowLongDoesTaxResolutionTake";

export const Route = createFileRoute("/resources/how-long-does-tax-resolution-take")({
  component: () => <HowLongDoesTaxResolutionTake />,
});
